import { render, staticRenderFns } from "./premium-features-table.vue?vue&type=template&id=0d4be994&"
import script from "./premium-features-table.vue?vue&type=script&lang=js&"
export * from "./premium-features-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports